module.exports = __webpack_public_path__ + "static/media/calendar-orange.ca9aa5cd.svg";